
import mModal from '../../mModal/index.vue';
import Datepicker from '@vuepic/vue-datepicker';
import moment from 'moment';
import 'moment/locale/ru';
import {PropType} from "vue";
import {Value, Interval} from "../src";

moment.locale('ru');


export default {
    emits: ['close', 'selectDate', 'update:modelValue'],
    components: {
        mModal,
        Datepicker,
    },
    props: {
        modelValue: {
            type: Object as PropType<Interval>
        }
    },
    computed: {
        formatDate(): string {
            return this.makeInterval().toString();
        },
    },
    methods: {
        makeInterval(): Interval {
            return new Interval(
                    this.dateStart ? new Date(this.dateStart): null,
                    this.dateEnd ? new Date(this.dateEnd) : null
            );
        },
        close() {
            this.$emit('close');
        },
        save() {
            this.errorDate = false;
            if (this.dateEnd && this.dateStart && this.dateEnd < this.dateStart) {
                this.errorDate = true;
            } else {
                this.onUpdateDate();
            }
        },
        onUpdateDate() {
            this.$emit('selectDate', this.makeInterval());
            this.close();
        }
    },
    created: function () {
        this.moment = moment;
    },
    data() {
        return {
            defaultDateText: 'Не выбрано',
            errorTextDate: 'Конец периода не может быть меньше начала периода!',
            errorDate: false,
            dateStart: this.modelValue?.start?.toISOString() || '',
            dateEnd: this.modelValue?.end?.toISOString() || '',
        }
    }
}
